import { SORT_FINDINGAIDS } from "./types";

export const sortFindingAids = (type, order) => async (dispatch, getState) => {
  let { findingAids } = getState().findingAids;

  if (type === "repository") {
    type = "repository_name";
  }

  const quickSort = async (arr, start, end) => {
    if (arr.length === 1) {
      return arr;
    }

    if (start >= end) {
      return;
    }

    let index = await partition(arr, start, end);

    await Promise.all([
      quickSort(arr, start, index - 1),
      quickSort(arr, index + 1, end),
    ]);

    return arr;
  };

  const partition = async (arr, start, end) => {
    let pivotValue = arr[end];
    let pivotIndex = start;

    const swapUp = async (left, right, index) => {
      if (left < right) {
        await swap(arr, index, pivotIndex);
        pivotIndex++;
      }
    };

    const swapDown = async (left, right, index) => {
      if (left > right) {
        await swap(arr, index, pivotIndex);
        pivotIndex++;
      }
    };

    const sortDates = (arr) => {
      let dates = arr.sort((a, b) => parseInt(a) - parseInt(b));
      let number_dates = dates.map((n) => parseInt(n));
      if (type === "end_dates") {
        return number_dates.reverse();
      } else {
        return number_dates;
      }
    };

    const validateDates = (value) => {
      let result = 0;
      if (typeof value === "object") {
        result = value[0];
      } else if (value === -1) {
        result = value;
      }
      return result;
    };

    for (let i = start; i < end; i++) {
      let checkPivotValue = pivotValue[type];
      let checkValue = arr[i][type];

      if (type === "title" || type === "repository_name") {
        if (order === "up") {
          await swapUp(
            checkValue.toLowerCase(),
            checkPivotValue.toLowerCase(),
            i
          );
        } else if (order === "down") {
          await swapDown(
            checkValue.toLowerCase(),
            checkPivotValue.toLowerCase(),
            i
          );
        }
      }

      if (type === "creators") {
        // Normalize pivot + value to arrays (so we never touch .length on undefined)
        if (checkPivotValue === undefined || checkPivotValue === null) {
          checkPivotValue = [""];
        } else if (Array.isArray(checkPivotValue)) {
          // keep as-is
        } else {
          checkPivotValue = [checkPivotValue];
        }

        if (checkValue === undefined || checkValue === null) {
          checkValue = [""];
        } else if (Array.isArray(checkValue)) {
          // keep as-is
        } else {
          checkValue = [checkValue];
        }

        // Sort creator arrays when multiple values exist
        if (checkPivotValue.length > 1) {
          checkPivotValue.sort((a, b) =>
            String(a).toLowerCase().localeCompare(String(b).toLowerCase())
          );
        }
        if (checkValue.length > 1) {
          checkValue.sort((a, b) =>
            String(a).toLowerCase().localeCompare(String(b).toLowerCase())
          );
        }

        // Compare first creator strings (case-insensitive)
        const pivotFirst =
          typeof checkPivotValue[0] === "string"
            ? checkPivotValue[0].toLowerCase()
            : String(checkPivotValue[0]).toLowerCase();

        const valueFirst =
          typeof checkValue[0] === "string"
            ? checkValue[0].toLowerCase()
            : String(checkValue[0]).toLowerCase();

        if (order === "up") {
          await swapUp(valueFirst, pivotFirst, i);
        } else if (order === "down") {
          await swapDown(valueFirst, pivotFirst, i);
        }
      }

      if (type === "start_dates" || type === "end_dates") {
        let datesPivot =
          checkPivotValue !== undefined ? sortDates(checkPivotValue) : -1;
        let datesCheck = checkValue !== undefined ? sortDates(checkValue) : -1;

        checkPivotValue = validateDates(datesPivot);
        checkValue = validateDates(datesCheck);

        if (order === "up") {
          await swapUp(checkValue, checkPivotValue, i);
        } else if (order === "down") {
          await swapDown(checkValue, checkPivotValue, i);
        }
      }
    }

    swap(arr, pivotIndex, end);
    return pivotIndex;
  };

  const swap = async (arr, a, b) => {
    let temp = arr[a];
    arr[a] = arr[b];
    arr[b] = temp;
  };

  let results = "";

  if (findingAids.length > 0) {
    results = await quickSort(findingAids, 0, findingAids.length - 1);
  }

  return dispatch({
    type: SORT_FINDINGAIDS,
    payload: [...results],
  });
};